export default (function($) {
    let $pageUrl;
    
    this.opts = {
    linkable: true,
  };

    this.pageUrl = window.location;

  this.init = (opts) => {
    Object.assign(this.opts, opts);
    this.pageUrl = window.location;
    this.modifyDOM();
    this.addEvents();
      this.setVars();
    this.helpers.checkURL.apply(this);
  };

  this.modifyDOM = () => {
  };

    this.setVars = () => {
        $pageUrl = window.location.href;
    };

  this.addEvents = () => {
    $('body').on('click', '.expander-hook', this.eventHandlers.onClick).
              on('click', '.expander__item__close', this.eventHandlers.onClose);

    window.onpopstate = this.helpers.checkURL;
  };

  this.eventHandlers = {
    onClick: e => {
      if (e.target.tagName === 'A') {
        return;
      }

      const id = e.currentTarget.getAttribute('data-id');

      if (this.opts.linkable) {
          const url = e.currentTarget.getAttribute('data-url');
        window.history.pushState({}, '', url);
      }

      if (this.helpers.currentlyOpen() == id) {
        this.helpers.close();
      } else if (this.helpers.currentlyOpen()) {
        this.helpers.replace(id);
      } else {
        this.helpers.open(id);
      }

      return false;
    },

    onClose: e => {
      this.helpers.close();
      return false;
    },
  };

  this.helpers = {
    checkURL: () => {
      const re = new RegExp(window.expanderRoot + "\\/([a-z0-9-]+)");
      const match = re.exec(window.location.pathname);

      if (match) {
        setTimeout(_ => {
          this.helpers.open(match[1]);
        }, 200);
      }
    },

    currentlyOpen: () => {
      if ($('.expander-hook.active').length) {
        return $('.expander-hook.active').data('id');
      }
    },

    open: id => {
      const $content = $('.expander-holder[data-id=' + id + ']');
      const html = $content.html();
      const $new = $('.expander-hook[data-id=' + id + ']');
      const $viewer = $('.expander-display');
      const $viewerInner = $('.expander-display');

      $new.addClass('active');
      $viewer.addClass('active');
      $new.css('margin-bottom', $content.height() + 65);

      setTimeout(function() {
        $viewerInner.html(html);
        $viewer.css('top', $new.offset().top + $new.height()).toggleClass('animate');
        $('html, body').animate({
          scrollTop: $viewer.offset().top - ($(window).height() / 3),
        }, 500);
      }, 300);
    },

    replace: id => {
      const $content = $('.expander-holder[data-id=' + id + ']');
      const html = $content.html();
      const $current = $('.expander-hook.active');
      const $new = $('.expander-hook[data-id=' + id + ']');
      const isSameRow = ($current.offset().top === $new.offset().top);
      const $viewer = $('.expander-display');
      const $viewerInner = $('.expander-display');

      $viewerInner.empty();

      if (isSameRow) {
        $current.addClass('no-transition');
        $new.addClass('no-transition');
      }

      $current.removeClass('active');
      $new.addClass('active');
      $current.css('margin-bottom', '3rem');
      $new.css('margin-bottom', $content.height() + 65);

      if (isSameRow) {
        $viewerInner.html(html);
        $viewer.css('top', $new.offset().top + $new.height());
        $current.removeClass('no-transition');
        $new.removeClass('no-transition');
      } else {
        setTimeout(function() {
          $viewerInner.html(html);
          $viewer.css('top', $new.offset().top + $new.height()).toggleClass('animate');
          $('html, body').animate({
            scrollTop: $viewer.offset().top - ($(window).height() / 3),
          }, 500);
        }, 300);
      }
    },

    close: () => {
      const $current = $('.expander-hook.active');
      const $viewer = $('.expander-display');
      const $viewerInner = $('.expander-display');

      $current.css('margin-bottom', '3rem');
      $('.expander-hook').removeClass('active');
      $viewer.removeClass('active');
      $viewerInner.empty();

      if (this.opts.linkable) {
          console.log($pageUrl);
        const url = $pageUrl;
        window.history.pushState({}, '', url);
      }
    },
  };

  return this.init;
}).call({}, jQuery);
